import {BaseWidget} from "./BaseWidget";

export class ColorFieldWidget extends BaseWidget {
    afterAttach() {
        super.afterAttach();
        let that = this;
        that.colorPicker = that.findElement().kendoColorPicker({
            clearButton: true,
            change: (e) => that.onEdit(that.readValueFromElement())
        }).data("kendoColorPicker");
        that.findElement().on("focus", (e) => {
            this.colorPicker.open()
        })
    }

    setValueInElement(value) {
        let picker = this.colorPicker;
        if (!value) {
            picker.color(null);
        } else {
            try {
                picker.value(value);
            } catch (e) {
                console.error("Error occurred while setting the value " + value + " in color picker with id " + this.id);
                console.error(e);
                picker.color(null);
            }
        }
    }

    readValueFromElement() {
        return this.colorPicker.value();
    }

    setEnabled(enabled) {
        this.colorPicker.enable(enabled);
    }

    shouldAddBlurHandler() {
        return false;
    }
}